module.exports = __webpack_public_path__ + "img/cold_face.b41120ef.gif";